import { PhoneInput } from '../../atoms'
import { BasicFormItem, BasicFormItemProps } from './BasicFormItem'

export const FormPhone = (props: Omit<BasicFormItemProps, 'component'>) => (
  <BasicFormItem component={PhoneInput} {...props} />
)
